// All-party-consent states — a business here must announce that the call is
// recorded. Keep in sync with Backend/src/lib/callRecordingStates.js.
export const STATES_REQUIRING_CALL_RECORDING = [
  "Washington",
  "Vermont",
  "Pennsylvania",
  "Oregon",
  "New Hampshire",
  "Nevada",
  "Montana",
  "Michigan",
  "Massachusetts",
  "Maryland",
  "Illinois",
  "Florida",
  "Delaware",
  "Connecticut",
  "California",
];

// Google returns the full name on some listings and only the 2-letter code on
// others, so match both — name-only matching silently missed the short form.
const STATE_CODES_REQUIRING_CALL_RECORDING = [
  "WA", "VT", "PA", "OR", "NH", "NV", "MT", "MI",
  "MA", "MD", "IL", "FL", "DE", "CT", "CA",
];

const norm = (v) => String(v ?? "").trim().toLowerCase();

// True when the business's state legally requires the recording declaration.
export const requiresCallRecording = (state, stateCode) => {
  const name = norm(state);
  if (name && STATES_REQUIRING_CALL_RECORDING.some((s) => norm(s) === name)) return true;
  const code = norm(stateCode);
  if (code && STATE_CODES_REQUIRING_CALL_RECORDING.some((c) => norm(c) === code)) return true;
  // A full name can also arrive in the code field (and vice-versa) — check across.
  if (code && STATES_REQUIRING_CALL_RECORDING.some((s) => norm(s) === code)) return true;
  if (name.length === 2 && STATE_CODES_REQUIRING_CALL_RECORDING.some((c) => norm(c) === name)) return true;
  return false;
};

export default requiresCallRecording;
